// extracted by mini-css-extract-plugin
module.exports = {"icon":"SvgIcon_icon__M54so","sm":"SvgIcon_sm__hbvEX"};